
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Musical Tribute </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm lata-mangeshkar section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>Forever Lata : <span > - A Musical Tribute to Bharat Ratna Lata Mangeshkar
                    Nagpur</span></h2>
        </div>

        <div class="row">
            <div class="col-lg-8">
                <div class=" text-justify">
                    <!-- <h2 class="head-lea">Lata Mangeshkar <span class="small-sm">25 February 2022 </span></h2> -->
                    <p>G. H Raisoni Sports and Cultural Foundation organizes ‘Forever Lata’ - A Musical Tribute to Lata
                        Mangeshkar ji. The event is powered by the Raisoni Group of Institutions and supported by G H
                        Raisoni University, and SGR Knowledge Foundation. ‘Forever Lata’ is a heartfelt tribute that
                        aims to celebrate the exceptional music of the legendary singer Lata Mangeshkar. The grand event
                        features a group of highly talented and well-known artists from Nagpur’s musical group ‘Sur
                        Sangam’, who performs Lata Mangeshkar's timeless songs, recalling her immense contribution to
                        Indian cinema.

                    </p>
                    <p> Earlier GHRSCF had organized the event in Nagpur, Chandrapur, Wardha and extended to other
                        different cities across Maharashtra. The event’s success usually depends on the testament to the
                        passion and commitment of the organizer G H Raisoni Sports and Cultural Foundation fits in and
                        celebrates India’s rich cultural heritage by organizing such events for the general public, free
                        of charge. The Initiative is supported and encouraged by Shri Sunil Raisoni, Chairman, Raisoni
                        Group of Institutions, He has been a driving force behind the event, and has made this
                        initiative possible.

                    </p>
                    <p>All the music enthusiasts, cinephiles, and the general public are invited to join the upcoming
                        event. For more details and registration visit the following link
                        Link:- <a href="https://www.ghrscf.com/cultural-events"
                            target="_blank">https://www.ghrscf.com/cultural-events</a> </p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-mangeshkar.webp"
                        alt="GHRSCF">
                </div>
            </div>

        </div>
        <div class="border-line-sm"></div>
        <div class="row">
            <div class="col-lg-8">

                <h2 class="head-lea">G H RAISONI SPORTS & CULTURAL FOUNDATION ORGANIZES - A MUSICAL TRIBUTE</h2>
                <p>Performer: Surbhi Dhomane, Manjiri Ayyer, shriya Mendhi, Mukul Pande, Ajay Mapk</p>
                <p>Music Arranger: Sachin Dhomane</p>
                <p>Date : Saturday, 25<sup>th</sup> February 2022</p>
                <p>Time : 6.30 pm</p>
                <p>Venue : Deshpande Hall, Civil pnes Nagpur</p>

            </div>
            <div class="col-md-4">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-mangeshkar-tribute.webp"
                        alt="GHRSCF">
                </div>
            </div>

        </div>
        <div class="border-line-sm"></div>
        <div class="row">
            <div class="col-lg-4">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-5">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Media Coverage</h4>
                            </div>
                        </div>
                        <div class="col-md-7 text-end">
                            <a href="videogallery" target="_blank" class="cmn-button"><span>
                                    YouTube link</span>
                            </a>
                        </div>
                    </div>
                    <iframe src="https://drive.google.com/file/d/12Yc4U3gFT2anozbmBILeA_pAi0fVkEP4/preview" height="230"
                        width="100%"></iframe>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-5">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">You can also visit</h4>
                            </div>
                        </div>
                        <div class="col-md-7 text-end">
                            <a href="videogallery" target="_blank" class="cmn-button"><span>
                                    YouTube link</span>
                            </a>
                        </div>
                    </div>
                    <iframe width="100%" height="230" src="https://www.youtube.com/embed/K0pEc5d6OQ8" frameborder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-5">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Photos</h4>
                            </div>
                        </div>
                        <div class="col-md-7 text-end">
                            <a href="photogallery" target="_blank" class="cmn-button"><span>
                                    View More</span>
                            </a>
                        </div>
                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/lata_m1.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/lata_m1.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/lata_m1.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/lata_m2.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/lata_m2.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/lata_m2.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/lata_m3.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/lata_m3.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/lata_m3.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/lata_m4.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/lata_m4.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/lata_m4.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/lata_m_5.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/lata_m_5.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/lata_m_5.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/lata_m_6.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/lata_m_6.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/lata_m_6.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>


                        </ul>
                    </div>
                </div>
            </div>


        </div>

    </div>
</section>
